import * as React from "react";
import "./MSList.scss";
  import MIPADatePicker from "../Common/datepicker";
  import { Callout } from "office-ui-fabric-react/lib/Callout";
  import {
    DirectionalHint,
    IContextualMenuItem
  } from "office-ui-fabric-react/lib/ContextualMenu";
import MIPAChoiceAction from "../Common/ChoiceAction";
import {MSListConfig,MSListFieldValue,MSListFiled,MSListItem} from '../../Entity/MySettingobj';
import MSListItemEdit from './MSListItemEdit';
import { DateHelper } from "../../Helpers/DateHelper";
export interface IProps {
    ListInfo: MSListConfig;
    ListItem:MSListItem;
    UpdateMethod;
    UserEmail;
    Users;
  }

  export default class MSListItemBlock extends React.Component<IProps> {  
   
    constructor(props) {
        super(props);    
       
        }
        private _menuButtonElement: HTMLElement | null;
    public state={DetailCalloutVisible:false,ShowEditModal:false,beakWidth: 16};
    public render() {
      let rowcss = "ms-Grid-row miparow";
      let webpartbody =
      this.props.ListItem.Col < 0
        ? ["webpartbody", "overdue"].join(" ")
        : "webpartbody"; 
    return (this.props.ListInfo!=null?(
      <div className="mslist">
            <div className="webpart" style={{borderColor:this.props.ListItem.Color}}>
            <div className="webpartTitle" style={{color:'white',background:this.props.ListItem.Color}}>
            <span className="ms-Icon ms-Icon--News"></span>
              
            {this.props.ListItem.Category}
            <i title="Edit" className="ms-Icon ms-Icon--EditSolid12 openlink" onClick={()=>{this.setState({ShowEditModal:true});}}></i>
            </div>
            <div className={webpartbody}>
            {this.prepareCustomData(rowcss)}
            </div>
          </div>
          {this.state.ShowEditModal?(
            <MSListItemEdit
              ListInfo={this.props.ListInfo}
              UpdateMethod={(fields)=>{
                let config={
                  SiteURL:this.props.ListInfo.SiteURL,
                  ListTitle:this.props.ListInfo.ListTitle,
                  UserEmail:this.props.UserEmail
                };
                this.props.UpdateMethod(config,fields);
                this.setState({ShowEditModal:false})
              }}
              ListItem={this.props.ListItem}
              UserEmail={this.props.UserEmail}
              UserList={this.props.Users}
              closeMethod={(val)=>{this.setState({ShowEditModal:val})}}
            ></MSListItemEdit>
          ):null}
      </div>
    ):null
      
    );
  }
  public prepareCustomData = rowcss => {
    let data = [];
    let flagfield=null;
    if(this.props.ListInfo.FlagField && this.props.ListInfo.FlagField.Name){
      flagfield=this.props.ListInfo.DisplayFields.filter((f=>{return f.Name==this.props.ListInfo.FlagField.Name}))[0];
    }
    
    let rendercallout=true;
    this.props.ListItem.Fields.map((customitem:MSListFieldValue, index) => {
      if(customitem.ShowInCard){
        let Rendervalue=null;
        if(flagfield!=null && customitem.FieldName==this.props.ListInfo.FlagField.Name){
          Rendervalue=(
            <MIPAChoiceAction contextbuttoncss='contextbutton flagaction' items={this.PrepareFlagItems(customitem.FieldValue,flagfield)}>
                            <div className={['bucket', 'ellips'].join(' ')}>{customitem.FieldValue}</div>
                          </MIPAChoiceAction>
          );
        }
        else if(this.props.ListInfo.DateField!=null && customitem.FieldName==this.props.ListInfo.DateField.Name){
          Rendervalue=(
            <div
                    className="dateleft"
                    title={customitem.FieldTitle}
                    style={{background:this.props.ListItem.Color}}
                  >
                    <MIPADatePicker
                      datevalue={customitem.FieldValue}
                      ChangeDate={date => {
                       
                        let fielddata:MSListFieldValue={
                          FieldTitle:customitem.FieldTitle,
                            FieldName:customitem.FieldName,
                            FieldValue:date,
                            FieldType:customitem.FieldType,
                          IDValue:this.props.ListItem.ID
                        };
                        let config={
                          SiteURL:this.props.ListInfo.SiteURL,
                          ListTitle:this.props.ListInfo.ListTitle,
                          UserEmail:this.props.UserEmail
                        };
                        this.props.UpdateMethod(config,[fielddata]);
                      }}
                    />
                  </div>
          );
        }
        else if(customitem.FieldType=='DateTime' && customitem.FieldValue!=null && customitem.FieldValue!=''){
          Rendervalue=DateHelper.GetDisplayDatestring(customitem.FieldValue,false);
        }
        else{
          //Rendervalue=customitem.FieldValue;
          Rendervalue=(<span dangerouslySetInnerHTML={{__html: customitem.FieldValue}} />);
        }
        data.push(
          <div   key={"Custom_" + index} className={rowcss}>
            <div className="ms-Grid-col ms-sm12">
              <div title={customitem.FieldValue} className="ellips">
                <b>{customitem.FieldTitle}: </b>  
                {Rendervalue}
                {rendercallout?(
                  <i className="ms-Icon ms-Icon--DietPlanNotebook detailsicon" 
                  ref={menuButton => (this._menuButtonElement = menuButton)}
                  onClick={this._onMenuClicked} title="Show Details" >
                  {this.state.DetailCalloutVisible?this.RenderDetailsView(rowcss):null}
                  
                  </i>
                ):null}
              </div>
            </div>
          </div>
        );
        rendercallout=false;
      }
    });
    return data;
  };
  public RenderDetailsView=(rowcss)=>{
    let data = [];
    this.props.ListItem.Fields.map((customitem:MSListFieldValue, index) => {
      if(customitem.ShowInDetails){
        let Rendervalue=null;
        if(customitem.FieldType=='DateTime' && customitem.FieldValue!=null && customitem.FieldValue!=''){
          Rendervalue=DateHelper.GetDisplayDatestring(customitem.FieldValue,false);
        }
        else{
          Rendervalue=customitem.FieldValue;
        }
        data.push(
          <div   key={"Custom_" + index} className={rowcss}>
            <div className="ms-Grid-col ms-sm12 ms-lg3">              
                <b>{customitem.FieldTitle}: </b>                 
            </div>
            <div className="ms-Grid-col ms-sm12  ms-lg9">
            <span dangerouslySetInnerHTML={{__html: Rendervalue}} />
              
            </div>
          </div>
        );
        
      }
    });
    let view=(
      <Callout
              className="ms-Callout-callout"
              onDismiss={this._onCalloutDismiss}
              target={this._menuButtonElement}
              directionalHint={DirectionalHint.topAutoEdge}
              coverTarget={false}
              isBeakVisible={true}
              gapSpace={0}
              beakWidth={this.state.beakWidth}
            >
              <div className="detailcallout">
                <div style={{background:this.props.ListItem.Color}}
                  className={["ms-Callout-header", "eventdetailheader"].join(
                    " "
                  )}
                >
                  {this.props.ListItem.Category}
                </div>
                <div className="ms-Callout-inner" style={{ padding: "10px",minWidth:'30vw'}}>
                  <div className="ms-Callout-content ms-Grid">
                    {data}
                  </div>
                </div>
              </div>
            </Callout>
    )
    return view;
  }
  public PrepareFlagItems(val,field:MSListFiled): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    field.Choices.forEach((element) => {
      let menu = {
        key: 'Flag_' + this.props.ListItem.ID + "_" + keyIndex,
        name: element,
        iconProps: {
          className: val == element ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        },
        onClick: () => {
          let fielddata:MSListFieldValue={
            FieldName:field.Name,
            FieldValue:element,
            FieldType:field.Type,
            FieldTitle:field.Title,
            IDValue:this.props.ListItem.ID
          };
          let config={
            SiteURL:this.props.ListInfo.SiteURL,
            ListTitle:this.props.ListInfo.ListTitle,
            UserEmail:this.props.UserEmail
          };
          this.props.UpdateMethod(config,[fielddata]);
          //this.UpdateSSOValue(this.props.data.ID,element.id,'IGlobeCRM_SSO_Pipeline','Choice',this.props.data.SSOColmn);
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }
  private _onCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false
    });
  };

  private _onMenuClicked = (): void => {
    this.setState({
      DetailCalloutVisible: !this.state.DetailCalloutVisible
    });
  };
}
